import { Navigate, useLocation } from 'react-router-dom';

import { useAuthUser } from 'auth/hooks';
import { Loader } from 'core/elements';
import { TriggerActions } from 'core/enums';
import { homePath } from 'home/routes';
import { hasRoutePermission } from 'router/utils';

interface IProps {
  path?: string;
  children?;
}

const PrivateRoute = ({ path, children }: IProps) => {
  const { user, isLoading, isFetched } = useAuthUser();
  const location = useLocation();

  if (isLoading) {
    return <Loader fullHeight />;
  }

  const permission = hasRoutePermission(path, user?.resources);

  if (isFetched && !user && !permission) {
    // Carry the denied page along: the sign-in form reads it back through
    // useSignInRedirectTarget, and without it a deep link is lost the moment
    // we navigate away — the visitor signs in and lands on the SPA root.
    return (
      <Navigate
        to={homePath(TriggerActions.SIGN_IN)}
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return children;
};

export default PrivateRoute;
